module.exports = __webpack_public_path__ + "static/media/play-store.04a9b28c.png";